





































import { Component, Vue } from "vue-property-decorator";
import { Form, FormBuilder } from "vue-formio";
import { Templates } from "formiojs";
import "formiojs/dist/formio.full.css";
import { IRelease } from "@/interfaces/orchestrator.interface";
import API from "../store/api";
import { WithRoute } from "@/router";
import { IProcessForm } from "@/interfaces/process-form.interface";

Templates.framework = "bootstrap";

// Part of the monkey-patch to not overwrite the component keys
function fastCloneDeep(obj: any) {
    return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

function emptyProcessForm(): IProcessForm {
    return {
        id: undefined as any,
        organization: undefined as any,
        releaseId: undefined as any,
        form: {}
    };
}

@Component({
    components: { FormBuilder, Form }
})
export default class ProcessFormTokenView extends Vue implements WithRoute {
    error: boolean = false;
    loading: boolean = false;
    processForm: IProcessForm = emptyProcessForm();
    release: IRelease | null = null;

    async onSubmit(e: any) {
        if (!e.data.submit) {
            return;
        }
        delete e.data.submit;
        const inputArguments = JSON.stringify(e.data);
        const token: string = this.$route.params.token;
        const result = await API.startNewJob(this.release!.Key, inputArguments, this.release!.OrganisationalUnitId, token);
    }

    acknowledgeError(): void {
        this.error = false;
    }

    async mounted() {
        this.loading = true;

        const token: string = this.$route.params.token;
        const result: IProcessForm | null = await API.redeemOrchestratorProcessToken(token);
        if(result === null) {
            this.error = true;
        } else {
            this.processForm = result;
            this.release = await API.getOrchestratorRelease(parseInt(this.processForm.releaseId), token);
        }

        this.loading = false;
    }

    get options() {
        return {
            language: "de",
            i18n: {
                de: {
                    Submit: "Ausführen",
                    "Basic Components": "Standard Komponenten",
                    "Drag and Drop a form component":
                        "Formular-Elemente hier durch Ziehen platzieren.",
                    "Process-Specific Elements": "Prozess-Spezifische Elemente",
                    Save: "Speichern",
                    Cancel: "Abbrechen",
                    Remove: "Entfernen"
                }
            }
        };
    }
}
